import { clsx } from 'clsx';
import { IJxtHomeSkeleton } from './types';

/**
 * Where data is still on its way: a pulsing shape of what comes, never an empty state that may not
 * be true. Hidden from screen readers: the block around says it is busy.
 */
const JxtHomeSkeleton = ({ className }: IJxtHomeSkeleton) => (
  <div aria-hidden className={clsx('animate-pulse rounded-xl bg-neutral-10', className)} />
);

export default JxtHomeSkeleton;
